import * as Draft from 'draft-js';

import { EditorEntityKind } from './editorEntityKind';

export type GetAllEntitiesResultItem = {
  entityKey: string;
  blockKey: string;
  entity: Draft.EntityInstance;
  start: number;
  end: number;
};

/**
 * Функция возвращает массив всех сущностей определенного типа в текущем состоянии редактора
 * @param editorState
 * @param entityType
 */
export const getAllEntities = (
  editorState: Draft.EditorState,
  entityType?: EditorEntityKind
): GetAllEntitiesResultItem[] => {
  const content: Draft.ContentState = editorState.getCurrentContent();

  const entities: GetAllEntitiesResultItem[] = [];

  content.getBlocksAsArray().forEach((block) => {
    let selectedEntity: GetAllEntitiesResultItem | null = null;

    block.findEntityRanges(
      (character) => {
        if (character.getEntity() !== null) {
          const entity = content.getEntity(character.getEntity());

          if (!entityType || (entityType && entity.getType() === entityType)) {
            selectedEntity = {
              entityKey: character.getEntity(),
              blockKey: block.getKey(),
              entity: content.getEntity(character.getEntity()),
              // Подмешиваем start и end на 52 строке,
              // поэтому здесь прокидываем любые невалидные значения
              start: -1,
              end: -1,
            };

            return true;
          }
        }

        return false;
      },
      (start, end) => {
        if (selectedEntity) {
          entities.push({ ...selectedEntity, start, end });
        }
      }
    );
  });

  return entities;
};
